(() => {
  'use strict';

  const VERSION = 'CANFOTO-E1-FINAL1-R2G-GLOBAL-SELECTOR-PARITY-R1';
  const SOURCE_SEAL = 'E1-F08-HOME-SOFT-GLOSS-PILL-HEADER-SLOT-R1-SEALED';
  const STORAGE_KEY = 'canfoto_experience_theme_v1';
  const ORDER = Object.freeze([
    'cf-editorial','cf-nature','cf-magazine','cf-newsroom','cf-chrome',
    'cf-cinema','cf-retrofuture','cf-redaxis','cf-hyperpop'
  ]);
  const META = Object.freeze({
    'cf-editorial':'Editorial Conversion',
    'cf-nature':'Nature Distilled Studio',
    'cf-magazine':'Magazine Commerce',
    'cf-newsroom':'Raw Newsroom',
    'cf-chrome':'Chrome Frame Future',
    'cf-cinema':'Cinema Light Dossier',
    'cf-retrofuture':'Retrofuture Signal',
    'cf-redaxis':'Red Axis Manifesto',
    'cf-hyperpop':'Hyperpop Grid'
  });
  const NORA_HERO = 'https://cdn.shopify.com/s/files/1/0739/2755/7269/files/NORA-HERO.png?v=1788417055';
  const NORA = Object.freeze({
    'cf-editorial':NORA_HERO,
    'cf-nature':NORA_HERO,
    'cf-magazine':NORA_HERO,
    'cf-newsroom':NORA_HERO,
    'cf-chrome':NORA_HERO,
    'cf-cinema':NORA_HERO,
    'cf-retrofuture':NORA_HERO,
    'cf-redaxis':NORA_HERO,
    'cf-hyperpop':NORA_HERO
  });

  const state = {
    version: VERSION,
    sourceSeal: SOURCE_SEAL,
    status: 'BOOTING',
    mountedDesktop: false,
    mountedMobile: false,
    storageOwner: STORAGE_KEY,
    themeOrder: ORDER.slice(),
    noraHeroUrl: NORA_HERO,
    noraMap: { ...NORA },
    mutation: Object.freeze({
      commerce: 'NONE', scoring: 'NONE', ranking: 'NONE', fp: 'NONE',
      setupTruth: 'NONE', geometryTruth: 'NONE', canonical: 'NONE'
    })
  };
  window.CANFOTO_E1_F08 = state;

  const isHome = () => document.body?.classList.contains('template-index');
  const MOTOR_NO_TOUCH_PATHS = Object.freeze([
    '/pages/led-isik-secim-motoru',
    '/pages/cob-led-secim-motoru',
    '/pages/panel-led-secim-motoru'
  ]);
  const isMotorNoTouch = () => MOTOR_NO_TOUCH_PATHS.includes(window.location.pathname.replace(/\/$/, ''));
  const api = () => window.CanFotoExperience || null;
  const current = () => {
    const a = api();
    const v = a?.get ? a.get() : document.documentElement.dataset.cfTheme;
    return ORDER.includes(v) ? v : ORDER[0];
  };
  const indexOf = (id) => Math.max(0, ORDER.indexOf(id));

  function syncNora(id) {
    const url = NORA[id] || NORA[ORDER[0]];
    document.querySelectorAll('[data-cf-f08-nora]').forEach((img) => {
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      img.dataset.cfF08NoraProfile = id;
      img.dataset.cfF08NoraUrl = url;
    });
  }

  function sync(id) {
    const idx = indexOf(id);
    document.querySelectorAll('[data-cf-f08-range]').forEach((input) => {
      if (Number(input.value) !== idx) input.value = String(idx);
      input.setAttribute('aria-valuetext', `${idx + 1} / 9 · ${META[id]}`);
      input.setAttribute('title', META[id]);
    });
    document.querySelectorAll('[data-cf-f08-status]').forEach((node) => {
      node.textContent = `${META[id]} · ${idx + 1} / 9`;
    });
    syncNora(id);
    state.current = id;
    state.currentIndex = idx;
  }

  function choose(index, source) {
    const a = api();
    if (!a?.set || a.storageKey !== STORAGE_KEY) {
      state.status = 'FAIL_CLOSED_NO_CANFOTO_EXPERIENCE_OWNER';
      return false;
    }
    const idx = Math.max(0, Math.min(8, Number(index) || 0));
    const id = ORDER[idx];
    a.set(id, { persist: true, source: source || 'E1-F08-CUSTOMER-SELECTOR' });
    sync(id);
    return true;
  }

  function build(kind) {
    const host = document.createElement('div');
    host.className = `cf-f08-selector cf-f08-selector--${kind}`;
    host.dataset.cfF08Selector = kind;
    host.dataset.cfF08Seal = SOURCE_SEAL;
    host.dataset.cfF08Order = ORDER.join('|');
    host.setAttribute('role', 'region');
    host.setAttribute('aria-label', kind === 'desktop' ? 'Can Foto görünüm seçimi' : 'Can Foto mobil görünüm seçimi');

    const shell = document.createElement('div');
    shell.className = 'cf-f08-selector__shell';
    shell.dataset.cfF08Shell = '1';

    const track = document.createElement('div');
    track.className = 'cf-f08-selector__track';

    const range = document.createElement('input');
    range.className = 'cf-f08-selector__range';
    range.type = 'range';
    range.min = '0';
    range.max = '8';
    range.step = '1';
    range.value = String(indexOf(current()));
    range.dataset.cfF08Range = kind;
    range.setAttribute('aria-label', 'Tema seçimi: soldan sağa açık temadan koyu temaya gider');
    /* no name attribute: selector never participates in native search form submission */
    range.addEventListener('input', () => choose(range.value, `E1-F08-${kind}-input`));
    range.addEventListener('change', () => choose(range.value, `E1-F08-${kind}-change`));
    range.addEventListener('keydown', (event) => {
      event.stopPropagation();
      if (event.key === 'Enter') event.preventDefault();
    });
    range.addEventListener('click', (event) => event.stopPropagation());

    const status = document.createElement('span');
    status.className = 'cf-f08-selector__status';
    status.dataset.cfF08Status = kind;
    status.setAttribute('aria-live', 'polite');

    track.append(range);
    shell.append(track);
    host.append(shell, status);
    return host;
  }

  function bindStatic(kind, host) {
    if (!host) return false;
    const range = host.querySelector('[data-cf-f08-range]');
    if (!range) return false;

    if (host.dataset.cfF08Bound !== '1') {
      range.addEventListener('input', () => choose(range.value, `E1-F08-${kind}-input`));
      range.addEventListener('change', () => choose(range.value, `E1-F08-${kind}-change`));
      range.addEventListener('keydown', (event) => {
        event.stopPropagation();
        if (event.key === 'Enter') event.preventDefault();
      });
      range.addEventListener('click', (event) => event.stopPropagation());
      host.dataset.cfF08Bound = '1';
    }
    return true;
  }

  function mountDesktop() {
    const field = document.querySelector('.header-section .header__smart-search .search__field, .headerx-transparent .search__field');
    const existing = document.querySelector('[data-cf-f08-selector="desktop"]');
    if (!field || !existing || existing.parentElement !== field) return;
    state.mountedDesktop = bindStatic('desktop', existing);
  }

  function mountMobile() {
    const header = document.querySelector('header.header');
    const existing = document.querySelector('[data-cf-f08-selector="mobile"]');
    if (!header || !existing) return;

    existing.dataset.cfGlobalMobileSelector = '1';
    /* P0-R1 CLS contract: markup is server-rendered immediately before header.
       Never move or inject it after first layout. */
    if (existing.nextElementSibling !== header) return;
    state.mountedMobile = bindStatic('mobile', existing);
  }

  function hideLegacyVoting() {
    document.querySelectorAll('[data-cf-home-voting],[data-canfoto-home-voting],#canfoto-theme-voting,.cf-home-voting,.canfoto-home-voting')
      .forEach((node) => {
        node.dataset.cfF08LegacyVoting = 'hidden-not-deleted';
        node.setAttribute('aria-hidden', 'true');
      });
  }

  function boot() {
    const a = api();
    if (!a?.set || !a?.get || a.storageKey !== STORAGE_KEY) {
      state.status = 'FAIL_CLOSED_NO_CANFOTO_EXPERIENCE_OWNER';
      return;
    }

    /* R2G contract:
       - the three LED motor routes are explicit NO-TOUCH and receive no selector mount;
       - every ordinary storefront page uses the same sealed HOME selector geometry;
       - desktop selector shares the native smart-search field;
       - mobile selector stays immediately above the native header row. */
    if (isMotorNoTouch()) {
      state.status = 'NO_TOUCH_MOTOR_PAGE';
      document.documentElement.dataset.cfF08Selector = state.status;
      document.documentElement.dataset.cfGlobalMobileSelector = 'NO_TOUCH';
      document.documentElement.dataset.cfGlobalDesktopSelector = 'NO_TOUCH';
      return;
    }

    mountDesktop();
    mountMobile();
    if (isHome()) hideLegacyVoting();
    sync(current());

    const ready = state.mountedMobile && state.mountedDesktop;
    state.status = ready ? 'READY_GLOBAL_PARITY' : 'HOLD_MOUNT_TARGET_MISSING';
    document.documentElement.dataset.cfF08Selector = state.status;
    document.documentElement.dataset.cfGlobalMobileSelector = state.mountedMobile ? 'READY' : 'HOLD';
    document.documentElement.dataset.cfGlobalDesktopSelector = state.mountedDesktop ? 'READY' : 'HOLD';
  }

  window.addEventListener('canfoto:experience-change', (event) => {
    const id = event?.detail?.current || current();
    sync(id);
  });
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 0));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.debugCanFotoE1F08 = () => {
    const a = api();
    const id = current();
    const d = document.querySelector('[data-cf-f08-selector="desktop"]');
    const m = document.querySelector('[data-cf-f08-selector="mobile"]');
    const compare = document.querySelectorAll('[data-cf-f08-light-compare="1"]');
    const fon = document.querySelector('.cf49-fon-curated');
    const footer = document.querySelector('.footer-group');
    const nora = document.querySelector('[data-cf-f08-nora]');
    const result = {
      ok: Boolean(
        isHome() && state.status === 'READY' && a?.storageKey === STORAGE_KEY &&
        d && m && compare.length === 1 && nora && nora.src === NORA[id]
      ),
      version: VERSION,
      sourceSeal: SOURCE_SEAL,
      status: state.status,
      current: id,
      storageKey: a?.storageKey || null,
      order: ORDER.slice(),
      desktopCount: document.querySelectorAll('[data-cf-f08-selector="desktop"]').length,
      mobileCount: document.querySelectorAll('[data-cf-f08-selector="mobile"]').length,
      compareCount: compare.length,
      fonBeforeCompare: Boolean(fon && compare[0] && (fon.compareDocumentPosition(compare[0]) & Node.DOCUMENT_POSITION_FOLLOWING)),
      compareBeforeFooter: Boolean(compare[0] && footer && (compare[0].compareDocumentPosition(footer) & Node.DOCUMENT_POSITION_FOLLOWING)),
      noraProfile: nora?.dataset?.cfF08NoraProfile || null,
      noraUrl: nora?.src || null,
      expectedNoraUrl: NORA[id],
      mutation: state.mutation
    };
    console.log('=== CANFOTO E1-F08 DEBUG ===');
    console.log(result);
    return result;
  };

  window.debugCanFotoGlobalMobileSelector = () => {
    const header = document.querySelector('header.header');
    const mobile = document.querySelector('[data-cf-f08-selector="mobile"]');
    const desktop = document.querySelector('[data-cf-f08-selector="desktop"]');
    const mobileInput = mobile?.querySelector('[data-cf-f08-range]');
    const desktopInput = desktop?.querySelector('[data-cf-f08-range]');
    const field = document.querySelector('.header-section .header__smart-search .search__field, .headerx-transparent .search__field');
    const excluded = isMotorNoTouch();
    const result = {
      ok: excluded
        ? (!mobile && !desktop && state.status === 'NO_TOUCH_MOTOR_PAGE')
        : Boolean(
            mobile && desktop && header && field &&
            mobile.nextElementSibling === header &&
            desktop.parentElement === field &&
            mobileInput && desktopInput &&
            !mobileInput.hasAttribute('name') && !desktopInput.hasAttribute('name')
          ),
      version: VERSION,
      pageType: isHome() ? 'HOME' : (excluded ? 'MOTOR_NO_TOUCH' : 'STOREFRONT'),
      status: state.status,
      current: current(),
      excludedMotorPage: excluded,
      mobileCount: document.querySelectorAll('[data-cf-f08-selector="mobile"]').length,
      desktopCount: document.querySelectorAll('[data-cf-f08-selector="desktop"]').length,
      mobileImmediatelyBeforeHeader: Boolean(mobile && header && mobile.nextElementSibling === header),
      desktopInsideSmartSearchField: Boolean(desktop && field && desktop.parentElement === field),
      mobileInputHasNoName: Boolean(mobileInput && !mobileInput.hasAttribute('name')),
      desktopInputHasNoName: Boolean(desktopInput && !desktopInput.hasAttribute('name')),
      mutation: state.mutation
    };
    console.log('=== CANFOTO FINAL1 R2G GLOBAL SELECTOR PARITY DEBUG ===');
    console.log(result);
    return result;
  };
})();
